"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWatchedRangesTime = void 0;
var getWatchedRangesTime = function (ranges) {
    if (!ranges)
        return 0;
    return ranges.reduce(function (acc, crr) { return acc + (crr.start + crr.end); }, 0);
};
exports.getWatchedRangesTime = getWatchedRangesTime;
